module.exports = __webpack_public_path__ + "Help Videos-dde31c3c1957406a82facd2f6bf7ae93.svg";